export var RouteRateLimitBucket;
(function (RouteRateLimitBucket) {
    RouteRateLimitBucket["LOWEST"] = "LOWEST";
    RouteRateLimitBucket["LOW"] = "LOW";
    RouteRateLimitBucket["MEDIUM"] = "MEDIUM";
    RouteRateLimitBucket["HIGH"] = "HIGH";
    RouteRateLimitBucket["HIGHEST"] = "HIGHEST";
})(RouteRateLimitBucket || (RouteRateLimitBucket = {}));
export var RouteRateLimitScope;
(function (RouteRateLimitScope) {
    RouteRateLimitScope["GLOBAL"] = "GLOBAL";
    RouteRateLimitScope["ACCOUNT"] = "ACCOUNT";
    RouteRateLimitScope["PRINCIPAL"] = "PRINCIPAL";
})(RouteRateLimitScope || (RouteRateLimitScope = {}));
//# sourceMappingURL=route-descriptor.enum.js.map